import i18n from 'i18next';
import { Api, uploadMedia } from 'lib';

async function submit({ dispatch, data, handleClose }) {
  dispatch({
    type: 'LOADING_BUTTON',
    payload: 'navigator'
  });

  let res = {};
  let shoutoutData = {
    comment: data.comment,
    entityId: data.entity?._id,
    eventId: data.eventObject?._id || undefined
  };

  if (data.media?.length) {
    const firstMedia =
      (data.media?.length && data.media[0].preview) ||
      data.metaData?.image ||
      (data.youtubeId && `https://img.youtube.com/vi/${data.youtubeId}/0.jpg`);

    const uploadedMedia = data.media?.length
      ? await Promise.all(data.media?.map((x, i) => uploadMedia(x, i)))
      : null;

    shoutoutData.media = uploadedMedia;
  }
  res = await Api.post('/shoutouts/create', shoutoutData);

  dispatch({
    type: 'LOADING_BUTTON',
    payload: null
  });
  if (!res) return;

  dispatch({
    type: 'SENT_SHOUTOUT',
    payload: res
  });

  dispatch({
    type: 'ADD_SHOUTOUT',
    payload: res
  });

  if (!data.media?.length) {
    dispatch({
      type: 'HANDLE_RES',
      payload: { res: i18n.t('shoutout.success') }
    });
  }

  handleClose();
}

export default submit;
